// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-settings-limit-input__text-input {
  width: 80px;
}
.dialog-settings-limit-input__label {
  display: inline-block;
  width: 125px;
  margin-right: 16px;
}`, "",{"version":3,"sources":["webpack://./src/ui/units/wizard/components/Dialogs/Settings/LimitInput/LimitInput.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAGI;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;AADR","sourcesContent":[".dialog-settings-limit-input__text-input {\n  width: 80px;\n}\n.dialog-settings-limit-input__label {\n  display: inline-block;\n  width: 125px;\n  margin-right: 16px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
